// src/data/gamesHubData.js

/**
 * ไฟล์นี้เก็บเฉพาะ "ข้อมูลเชิง config" ของหน้า GamesHubPage
 * เช่น id, path, หมวด, icon, className สี และ key สำหรับเรียกข้อความจาก i18n
 *
 * ข้อความที่แสดงบนหน้าเว็บจริง เช่น title, description, instruction
 * ให้เก็บไว้ในไฟล์ i18n JSON เช่น th.json / en.json
 */

export const gamesHubFilters = [
  {
    id: "all",
    labelKey: "gamesHub.filters.all",
    icon: "🌈",
  },
  {
    id: "story",
    labelKey: "gamesHub.filters.story",
    icon: "📖",
  },
  {
    id: "learning",
    labelKey: "gamesHub.filters.learning",
    icon: "✍️",
  },
  {
    id: "care",
    labelKey: "gamesHub.filters.care",
    icon: "🧹",
  },
  {
    id: "creative",
    labelKey: "gamesHub.filters.creative",
    icon: "🎨",
  },
];

export const difficultyClassMap = {
  easy: "bg-green-100 text-green-700 border-green-200",
  medium: "bg-amber-100 text-amber-700 border-amber-200",
  focus: "bg-blue-100 text-blue-700 border-blue-200",
  challenging: "bg-rose-100 text-rose-700 border-rose-200",
  eyesight: "bg-yellow-100 text-yellow-700 border-yellow-200",
  quickThinking: "bg-pink-100 text-pink-700 border-pink-200",
};

export const gamesHubItems = [
  {
    id: 7,
    slug: "mattanapatha",
    titleKey: "gamesHub.games.mattanapatha.title",
    subtitleKey: "gamesHub.games.mattanapatha.subtitle",
    typeKey: "gamesHub.games.mattanapatha.type",
    descriptionKey: "gamesHub.games.mattanapatha.description",
    instructionKey: "gamesHub.games.mattanapatha.instruction",
    timeKey: "gamesHub.games.mattanapatha.time",
    skillKey: "gamesHub.games.mattanapatha.skill",
    difficultyKey: "gamesHub.difficulty.easy",
    difficultyStyle: "easy",
    category: "story",
    icon: "📖",
    emojiBg: "bg-purple-100",
    cardBg: "from-purple-50 via-white to-fuchsia-50",
    border: "border-purple-200",
    text: "text-purple-700",
    button: "bg-purple-600 hover:bg-purple-700",
    link: "/games/matanapatha",
  },
  {
    id: 8,
    slug: "mattanaGarden",
    titleKey: "gamesHub.games.mattanaGarden.title",
    subtitleKey: "gamesHub.games.mattanaGarden.subtitle",
    typeKey: "gamesHub.games.mattanaGarden.type",
    descriptionKey: "gamesHub.games.mattanaGarden.description",
    instructionKey: "gamesHub.games.mattanaGarden.instruction",
    timeKey: "gamesHub.games.mattanaGarden.time",
    skillKey: "gamesHub.games.mattanaGarden.skill",
    difficultyKey: "gamesHub.difficulty.easy",
    difficultyStyle: "easy",
    category: "care",
    icon: "🌹",
    emojiBg: "bg-rose-100",
    cardBg: "from-rose-50 via-white to-pink-50",
    border: "border-rose-200",
    text: "text-rose-700",
    button: "bg-rose-600 hover:bg-rose-700",
    link: "/games/mattana-garden",
  },
  {
    id: 10,
    slug: "thaiHeritageBooth",
    titleKey: "gamesHub.games.thaiHeritageBooth.title",
    subtitleKey: "gamesHub.games.thaiHeritageBooth.subtitle",
    typeKey: "gamesHub.games.thaiHeritageBooth.type",
    descriptionKey: "gamesHub.games.thaiHeritageBooth.description",
    instructionKey: "gamesHub.games.thaiHeritageBooth.instruction",
    timeKey: "gamesHub.games.thaiHeritageBooth.time",
    skillKey: "gamesHub.games.thaiHeritageBooth.skill",
    difficultyKey: "gamesHub.difficulty.easy",
    difficultyStyle: "easy",
    category: "creative",
    icon: "🏢",
    emojiBg: "bg-indigo-100",
    cardBg: "from-indigo-50 via-white to-sky-50",
    border: "border-indigo-200",
    text: "text-indigo-700",
    button: "bg-indigo-600 hover:bg-indigo-700",
    link: "/face-swap",
  },
  {
    id: 2,
    slug: "ancientBookRestorer",
    titleKey: "gamesHub.games.ancientBookRestorer.title",
    subtitleKey: "gamesHub.games.ancientBookRestorer.subtitle",
    typeKey: "gamesHub.games.ancientBookRestorer.type",
    descriptionKey: "gamesHub.games.ancientBookRestorer.description",
    instructionKey: "gamesHub.games.ancientBookRestorer.instruction",
    timeKey: "gamesHub.games.ancientBookRestorer.time",
    skillKey: "gamesHub.games.ancientBookRestorer.skill",
    difficultyKey: "gamesHub.difficulty.medium",
    difficultyStyle: "medium",
    category: "care",
    icon: "🧹",
    emojiBg: "bg-amber-100",
    cardBg: "from-amber-50 via-white to-orange-50",
    border: "border-amber-200",
    text: "text-amber-800",
    button: "bg-amber-600 hover:bg-amber-700",
    link: "/games/dust-cleaner-game",
  },
  {
    id: 3,
    slug: "scriptDetective",
    titleKey: "gamesHub.games.scriptDetective.title",
    subtitleKey: "gamesHub.games.scriptDetective.subtitle",
    typeKey: "gamesHub.games.scriptDetective.type",
    descriptionKey: "gamesHub.games.scriptDetective.description",
    instructionKey: "gamesHub.games.scriptDetective.instruction",
    timeKey: "gamesHub.games.scriptDetective.time",
    skillKey: "gamesHub.games.scriptDetective.skill",
    difficultyKey: "gamesHub.difficulty.focus",
    difficultyStyle: "focus",
    category: "learning",
    icon: "✍️",
    emojiBg: "bg-emerald-100",
    cardBg: "from-emerald-50 via-white to-teal-50",
    border: "border-emerald-200",
    text: "text-emerald-800",
    button: "bg-emerald-600 hover:bg-emerald-700",
    link: "/games/script-tracing-game",
  },
  {
    id: 11,
    slug: "canvaGame",
    titleKey: "gamesHub.games.canvaGame.title",
    subtitleKey: "gamesHub.games.canvaGame.subtitle",
    typeKey: "gamesHub.games.canvaGame.type",
    descriptionKey: "gamesHub.games.canvaGame.description",
    instructionKey: "gamesHub.games.canvaGame.instruction",
    difficultyKey: "gamesHub.difficulty.easy",
    difficultyStyle: "easy",
    category: "learning",
    icon: "🌿",
    emojiBg: "bg-green-100",
    cardBg: "from-green-50 via-white to-emerald-50",
    border: "border-green-200",
    text: "text-green-700",
    button: "bg-green-600 hover:bg-green-700",
    link: "/games/lanna-food",
  },
  {
    id: 12,
    slug: "lannaChef",
    titleKey: "gamesHub.games.lannaChef.title",
    subtitleKey: "gamesHub.games.lannaChef.subtitle",
    typeKey: "gamesHub.games.lannaChef.type",
    descriptionKey: "gamesHub.games.lannaChef.description",
    instructionKey: "gamesHub.games.lannaChef.instruction",
    difficultyKey: "gamesHub.difficulty.medium",
    difficultyStyle: "medium",
    category: "learning",
    icon: "🍜",
    emojiBg: "bg-orange-100",
    cardBg: "from-orange-50 via-white to-amber-50",
    border: "border-orange-200",
    text: "text-orange-700",
    button: "bg-orange-600 hover:bg-orange-700",
    link: "/games/lanna-chef",
  },
];

/**
 * เกมสำรอง/เกมที่เคย comment ไว้ในไฟล์เดิม
 * ยังไม่ได้รวมเข้า gamesHubItems เพื่อไม่ให้แสดงบนหน้าเว็บทันที
 *
 * ถ้าต้องการเปิดใช้งานเกมไหน ให้คัดลอก object จาก gamesHubHiddenItems
 * ไปใส่ใน gamesHubItems ด้านบน และตรวจสอบ route ใน React Router ให้เรียบร้อย
 */
export const gamesHubHiddenItems = [
  {
    id: 11,
    slug: "canvaGame",
    titleKey: "gamesHub.games.canvaGame.title",
    subtitleKey: "gamesHub.games.canvaGame.subtitle",
    typeKey: "gamesHub.games.canvaGame.type",
    descriptionKey: "gamesHub.games.canvaGame.description",
    instructionKey: "gamesHub.games.canvaGame.instruction",
    difficultyKey: "gamesHub.difficulty.easy",
    difficultyStyle: "easy",
    category: "learning",
    icon: "🌿",
    emojiBg: "bg-green-100",
    cardBg: "from-green-50 via-white to-emerald-50",
    border: "border-green-200",
    text: "text-green-700",
    button: "bg-green-600 hover:bg-green-700",
    link: "/games/lanna-food",
  },
  {
    id: 12,
    slug: "lannaChef",
    titleKey: "gamesHub.games.lannaChef.title",
    subtitleKey: "gamesHub.games.lannaChef.subtitle",
    typeKey: "gamesHub.games.lannaChef.type",
    descriptionKey: "gamesHub.games.lannaChef.description",
    instructionKey: "gamesHub.games.lannaChef.instruction",
    difficultyKey: "gamesHub.difficulty.medium",
    difficultyStyle: "medium",
    category: "learning",
    icon: "🍜",
    emojiBg: "bg-orange-100",
    cardBg: "from-orange-50 via-white to-amber-50",
    border: "border-orange-200",
    text: "text-orange-700",
    button: "bg-orange-600 hover:bg-orange-700",
    link: "/games/lanna-chef",
  },
  {
    id: 13,
    slug: "regionalChef",
    titleKey: "gamesHub.games.regionalChef.title",
    subtitleKey: "gamesHub.games.regionalChef.subtitle",
    typeKey: "gamesHub.games.regionalChef.type",
    descriptionKey: "gamesHub.games.regionalChef.description",
    instructionKey: "gamesHub.games.regionalChef.instruction",
    difficultyKey: "gamesHub.difficulty.challenging",
    difficultyStyle: "challenging",
    category: "learning",
    icon: "🥘",
    emojiBg: "bg-red-100",
    cardBg: "from-red-50 via-white to-orange-50",
    border: "border-red-200",
    text: "text-red-700",
    button: "bg-red-600 hover:bg-red-700",
    link: "/games/regional-chef",
  },
  {
    id: 1,
    slug: "seamsiGame",
    titleKey: "gamesHub.games.seamsiGame.title",
    subtitleKey: "gamesHub.games.seamsiGame.subtitle",
    typeKey: "gamesHub.games.seamsiGame.type",
    descriptionKey: "gamesHub.games.seamsiGame.description",
    instructionKey: "gamesHub.games.seamsiGame.instruction",
    difficultyKey: "gamesHub.difficulty.easy",
    difficultyStyle: "easy",
    category: "creative",
    icon: "🥠",
    emojiBg: "bg-red-100",
    cardBg: "from-red-50 via-white to-rose-50",
    border: "border-red-200",
    text: "text-red-700",
    button: "bg-red-600 hover:bg-red-700",
    link: "/games/seamsi-game",
  },
  {
    id: 4,
    slug: "tungCatcher",
    titleKey: "gamesHub.games.tungCatcher.title",
    subtitleKey: "gamesHub.games.tungCatcher.subtitle",
    typeKey: "gamesHub.games.tungCatcher.type",
    descriptionKey: "gamesHub.games.tungCatcher.description",
    instructionKey: "gamesHub.games.tungCatcher.instruction",
    difficultyKey: "gamesHub.difficulty.challenging",
    difficultyStyle: "challenging",
    category: "creative",
    icon: "🚩",
    emojiBg: "bg-sky-100",
    cardBg: "from-sky-50 via-white to-cyan-50",
    border: "border-sky-200",
    text: "text-sky-700",
    button: "bg-sky-600 hover:bg-sky-700",
    link: "/games/tung-catcher-game",
  },
  {
    id: 5,
    slug: "pagodaStacker",
    titleKey: "gamesHub.games.pagodaStacker.title",
    subtitleKey: "gamesHub.games.pagodaStacker.subtitle",
    typeKey: "gamesHub.games.pagodaStacker.type",
    descriptionKey: "gamesHub.games.pagodaStacker.description",
    instructionKey: "gamesHub.games.pagodaStacker.instruction",
    difficultyKey: "gamesHub.difficulty.eyesight",
    difficultyStyle: "eyesight",
    category: "creative",
    icon: "🛕",
    emojiBg: "bg-yellow-100",
    cardBg: "from-yellow-50 via-white to-amber-50",
    border: "border-yellow-200",
    text: "text-yellow-700",
    button: "bg-yellow-600 hover:bg-yellow-700",
    link: "/games/pagoda-stacker-game",
  },
  {
    id: 6,
    slug: "roseRain",
    titleKey: "gamesHub.games.roseRain.title",
    subtitleKey: "gamesHub.games.roseRain.subtitle",
    typeKey: "gamesHub.games.roseRain.type",
    descriptionKey: "gamesHub.games.roseRain.description",
    instructionKey: "gamesHub.games.roseRain.instruction",
    difficultyKey: "gamesHub.difficulty.quickThinking",
    difficultyStyle: "quickThinking",
    category: "creative",
    icon: "🌹",
    emojiBg: "bg-pink-100",
    cardBg: "from-pink-50 via-white to-rose-50",
    border: "border-pink-200",
    text: "text-pink-700",
    button: "bg-pink-600 hover:bg-pink-700",
    link: "/games/rose-rain-game",
  },
];